export const PHOTO_CATEGORIES = {
  COMMUNITIES: {
    name: 'Community Photos',
    value: 'communities'
  },
  GROUPS: {
    name: 'Group Photos',
    value: 'groups'
  },
  PERSONAL_ALBUMS: {
    name: 'My Photos',
    value: 'personalAlbums'
  }
};

export const VIDEO_CATEGORIES = {
  COMMUNITIES: {
    name: 'Community Videos',
    value: 'communities'
  },
  GROUPS: {
    name: 'Group Videos',
    value: 'groups'
  },
  PERSONAL_ALBUMS: {
    name: 'My Videos',
    value: 'personalAlbums'
  }
};

export const ALL_MEDIA_SUBCATEGORY_ID = -999;
